import React from 'react';

interface PotentialBadgeProps {
  score: number;
  size?: 'sm' | 'md';
}

const PotentialBadge: React.FC<PotentialBadgeProps> = ({ score, size = 'sm' }) => {
  const isHighPotential = score >= 70;
  
  const sizeClasses = size === 'sm' 
    ? 'text-[10px] px-2 py-0.5' 
    : 'text-xs px-3 py-1';

  return (
    <span className={`${sizeClasses} font-black rounded-full border uppercase tracking-tighter shrink-0 ${
      isHighPotential
        ? 'bg-rose-50 text-rose-600 border-rose-100'
        : 'bg-slate-50 text-slate-500 border-slate-100'
    }`}>
      {isHighPotential ? 'High Potential' : 'Low Potential'}
    </span>
  );
};

export default PotentialBadge;
